import React from "react";

export enum PhaseStatus {
  PRETESTING = "pretesting",
  ACTIVE_REPORTING = "active_reporting",
  PENDING_AUTH = "pending_auth"
}

// Helper function to convert string to PhaseStatus enum
export const toPhaseStatus = (phase?: string | PhaseStatus): PhaseStatus => {
  if (!phase) return PhaseStatus.ACTIVE_REPORTING;
  if (typeof phase === "string") {
    switch (phase) {
      case "pretesting":
        return PhaseStatus.PRETESTING;
      case "pending_auth":
        return PhaseStatus.PENDING_AUTH;
      default:
        return PhaseStatus.ACTIVE_REPORTING;
    }
  }
  return phase;
};

interface PhaseStatusPillProps {
  status?: PhaseStatus;
  className?: string;
}

const PhaseStatusPill: React.FC<PhaseStatusPillProps> = ({ status = PhaseStatus.ACTIVE_REPORTING, className = "" }) => {
  const baseClassName = "text-center rounded-full px-3 py-1 font-medium text-xs";

  switch (status) {
    case PhaseStatus.PRETESTING:
      return (
        <span className={`bg-yellow-100 text-yellow-800 ${baseClassName} ${className}`}>
          Pretesting Phase
        </span>
      );
    case PhaseStatus.ACTIVE_REPORTING:
      return (
        <span
          className={`bg-green-100 text-green-800 ${baseClassName} ${className}`}
        >
          Reporting Phase
        </span>
      );
    case PhaseStatus.PENDING_AUTH:
      return (
        <span
          className={`bg-red-100 text-red-800 border border-red-200 ${baseClassName} ${className}`}
        >
          Pending Auth
        </span>
      );
    default:
      return (
        <span className={`bg-gray-100 text-gray-800 ${baseClassName} ${className}`}>
          Unknown Phase
        </span>
      );
  }
};

export default PhaseStatusPill;
